import script from "./BlockHintAddTicker.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockHintAddTicker.vue?vue&type=script&setup=true&lang=js"

import "./BlockHintAddTicker.vue?vue&type=style&index=0&id=c2b1ebf6&lang=scss"

const __exports__ = script;

export default __exports__